<script lang="ts">
import { ThemeType } from '@goodlifeplus/themes'
import { defineComponent } from 'vue'

/**
 * A modal to display YouTube videos.
 */
export default defineComponent({
  props: {
    id: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
  setup() {
    return { ThemeType }
  },
  computed: {
    hideVideo(): boolean {
      return (
        this.$theme.name === 'true-north' || this.$theme.type === ThemeType.Club
      )
    },
    modalId(): string {
      return `youtube-modal-${this.id}`
    },
  },
})
</script>

<template>
  <div class="relative">
    <slot v-if="hideVideo" :open-modal="() => {}" />
    <AppModal
      v-else
      :id="modalId"
      class="h-[300px] w-[90vw] max-w-[700px] max-h-[80vh] sm:h-[400px] overflow-visible"
      button-class="w-full"
      :aria-label="title"
      :allow-dismissal="false"
    >
      <template #button="{ openModal }">
        <slot :open-modal />
      </template>

      <template #default="{ isOpen, closeModal }">
        <iframe
          v-if="isOpen"
          class="youtube-iframe"
          :src="`https://www.youtube.com/embed/${id}?autoplay=1&rel=0&controls=1&showinfo=0`"
          allowfullscreen
          frameborder="0"
          loading="lazy"
          allow="autoplay; encrypted-media"
          :title
        />
        <AppButton
          v-if="isOpen"
          class="button-primary absolute -bottom-16 left-1/2 -translate-x-1/2 z-50"
          @click="closeModal(true)"
        >
          Close
        </AppButton>
      </template>
    </AppModal>
  </div>
</template>

<style lang="scss" scoped>
.youtube-iframe {
  @apply h-full w-full;
}
</style>
